/**
 * 寻找首个未使用的最小编号
 * @param folders 文件夹列表
 * @param defaultPrefix 默认前缀
 */
export function getNextName<T extends {
  folderName?: string; name?: string
}>(folders: T[], defaultPrefix: string) {
  const defaultPattern = new RegExp(`^${defaultPrefix}\\s+(\\d+)$`);

  // 提取所有匹配项后缀的数字，并存入 Set 以提高查询效率
  const usedNumbers = new Set<number>();

  folders.forEach(item => {
    const name = item.folderName || item.name;
    // 处理完全相等的情况（如果没有编号，可以视作 0 或处理成 1）
    if (name === defaultPrefix) {
      usedNumbers.add(1);
    }

    const match = name?.match(defaultPattern);
    if (match && match[1]) {
      usedNumbers.add(parseInt(match[1], 10));
    }
  });

  // 从 1 开始向上遍历，找到第一个不在 Set 中的数字
  let nextNumber = 1;
  while (usedNumbers.has(nextNumber)) {
    nextNumber++;
  }

  return `${defaultPrefix} ${nextNumber}`;
};